<template>
  <modal :show.sync="modalDocs" modalClasses="documents-modal">
    <h4 slot="header" class="title text-purple">
      {{ $t("app.modules.orders.documents.current_documents") }}
    </h4>
    <div class="col-sm-12">
      <div class="row">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            prop="fechaCreacion"
            :label="$t('app.modules.orders.documents.date_attached')"
            min-width="200"
          >
          </el-table-column>
          <el-table-column
            prop="tipoDocumento"
            :label="$t('app.modules.orders.documents.doc_type')"
            min-width="230"
          >
          </el-table-column>
          <el-table-column
            prop="documento"
            :label="$t('app.modules.orders.documents.link')"
            min-width="230"
          >
            <template slot-scope="scope">
              <el-link
                :href="server + scope.row.documento"
                target="_blank"
                icon="el-icon-document"
              >{{ $t("app.modules.orders.documents.single") }}</el-link
              >
              <span style="margin-left: 10px">{{ scope.row.date }}</span>
            </template>
          </el-table-column>
          <el-table-column width-min="200">
            <div slot-scope="props" class="table-actions dropdown">
              <el-popover
                placement="bottom"
                width="300"
                trigger="click"
                :ref="'refOption' + props.$index"
              >
                <div class="row">
                  <div class="col-12 options">
                    <n-button
                      @click.native="
                        promptDelete(
                          props.$index,
                          props.row,
                          'refOption' + props.$index
                        )
                      "
                      type="primary"
                      class="options-button"
                      size="sm"
                      round
                    >
                      {{ $t("app.buttons.delete") }}
                    </n-button>
                  </div>
                </div>
                <n-button
                  slot="reference"
                  size="sm"
                  icon
                  class="button-options-table"
                >
                  <i class="fa fa-ellipsis-v" style="color:black;"></i>
                </n-button>
              </el-popover>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div slot="footer" class="text-right">
      <n-button class="btn-secondary" @click.native="cancelDocs">{{
          $t("app.buttons.close")
        }}</n-button>
    </div>
  </modal>
</template>
<script>
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      server: "",
      tableData: [],
      file_doc: "",
      selectedEmptyOption: false,
      fileEmpty: false,
      docsTypes: [],
      selectedEmpty: false,
      required_text: this.$t("app.general.required"),
      item: { tipo_documento: 0 },
      modalDocs: false
    };
  },
  watch: {},
  computed: {},
  created() {
    this.server = process.env.VUE_APP_API_ENDPOINT;
  },
  async mounted() {
    EventBus.$on("pedidos-docs-table", async item => {
      console.log("llegó dato");
      this.item.idPedido = item.idPedido;
      this.tableData = [];
      this.initPedidosDocs();
      this.modalDocs = true;
    });
  },
  methods: {
    async promptDelete(index, row, ref) {
      this.$refs[ref].doClose();
      this.$confirm(
        this.$t("app.modules.orders.documents.message_delete"),
        "",
        {
          confirmButtonText: this.$t("app.modules.messages.alert.yes"),
          cancelButtonText: this.$t("app.modules.messages.alert.cancel"),
          //type: "warning",
          center: true
        }
      )
        .then(async () => {
          this.deleteDoc(row);
        })
        .catch(() => {});
    },
    async initPedidosDocs() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.getDocsById();
      this.$swal.close();
    },
    cancelDocs() {
      this.modalDocs = false;
    },
    async deleteDoc(row) {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      var del_item = {
        id: row.idPedidoDocumento,
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario
      };
      await this.$http
        .post(route("PedidoDocumento/deletePedidoDocumento"), del_item)
        .then(
          async response => {
            if (response.body.code === 200) {
              await this.initPedidosDocs();
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            console.log(error);
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {
          // Swal.close();
        });
      this.$swal.close();
    },
    onClick() {
      this.$refs.upload.clearFiles();
      this.file_doc = "";
    },
    async getDocsById() {
      var pay_l = {
        id: this.item.idPedido,
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario
      };
      await this.$http
        .post(route("PedidoDocumento/getPedidoDocumentos"), pay_l)
        .then(
          async response => {
            if (response.body.code === 200) {
              this.tableData = response.body.pedidosDocumentos;
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            console.log(error);
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {
          // Swal.close();
        });
    },
    handleFile(file) {
      if (file) {
        var extension = this.getFileExtension1(file.name);
        if (extension) {
          if (this.file_formats.includes(extension)) {
            this.file_doc = file.raw;
          } else {
            this.file_doc = "";
            this.$refs.upload.clearFiles();
            this.notifyMessage(
              "warning",
              this.$t("app.modules.orders.documents.message_incorrect")
            );
          }
        } else {
          this.file_doc = "";
          this.$refs.upload.clearFiles();
          this.notifyMessage(
            "warning",
            this.$t("app.modules.orders.documents.message_incorrect")
          );
        }
      }
    },
    async deleteFile(file) {
      this.file_doc = "";
    }
  }
};
</script>
<style>
.modal-dialog.documents-modal {
  max-width: 95% !important;
}
</style>
